
import { Vue, Component } from 'vue-property-decorator'
import AboutUsContent from '@/components/layout/AboutUsContent.vue'
import VerticalHeading from '@/components/typography/VerticalHeading.vue'
import SignUpBanner from '@/components/layout/SignUpBanner.vue'
import FaqDropdown from '@/components/collections/home/FaqDropdown.vue'
import { Config } from 'tradingmate-modules/src/environment'

@Component({
  components: {
    AboutUsContent,
    VerticalHeading,
    SignUpBanner,
    FaqDropdown
  }
})

export default class Faqs extends Vue {
  private isOpen = false

  CtaClicked (): void {
    window.open(Config.WebsiteUrls.Console + '/account/register', '_self')
  }

  SearchClicked (): void {
    window.open('/members', '_self')
  }
}

